<template>
    <div class="deteil">
        <el-card class="box-card">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">用户管理</el-breadcrumb-item>
                <el-breadcrumb-item>列表</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <el-row style="margin-top:20px;">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row :gutter="15">
                        <el-col :span="1.2"
                            ><div class="grid-content bg-purple">
                                <span>用户名称:</span>
                            </div></el-col
                        >
                        <el-col :span="5"
                            ><div class="grid-content bg-purple">
                                <el-input v-model="searchInput" placeholder="请输入用户名称" clearable></el-input></div
                        ></el-col>
                        <el-col :span="15">
                            <el-button type="primary" icon="el-icon-search" @click="Search()">查询</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="tableData" style="width: 100%" border>
                        <el-table-column :resizable="false" type="index" label="序号" width="50">
                                <template slot-scope="scope">{{ scope.$index + 1 + searchInfo.pageSize * (searchInfo.pageNum - 1) }}</template>
                        </el-table-column>
                        <el-table-column :resizable="false" prop="nickName" label="用户名称"  align="center"></el-table-column>
                        <el-table-column :resizable="false" prop="gender" label="性别"  align="center">
                                <template slot-scope="scope">{{ scope.row.gender==1?'男':scope.row.gender==2?'女':'暂无' }}</template>
                        </el-table-column>
                        <el-table-column prop="telephone" label="联系电话" :resizable="false"  align="center"></el-table-column>
                        <el-table-column prop="createTime" label="创建时间" :resizable="false"  align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.createTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页区域 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchInfo.pageNum"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data() {
        return {
            searchInput: '',
            // 查询参数
            searchInfo: {
                // 默认请求第一页
                pageNum: 1,
                // 默认请求10条数据
                pageSize: 10,
                nickName: '' //用户名称
            },
            // 日期
            date: null,
            // 数据列表
            tableData: [],
            // 数据总数
            total: 0
            // 下拉框的数据列表
        };
    },
    created() {
        // 获取数据列表
        this.getSysInfoList();
    },
    methods: {
        async Search() {
            console.log(this.searchInput);
            const res = await this.$axios.post('backstage/user/list', { nickName: this.searchInput, pageNum: 1, pageSize: 10 });
            console.log(res);
            if (res.data.code == 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
        async getSysInfoList() {
            const res = await this.$axios.post('backstage/user/list', this.searchInfo);
            console.log(res);

            if (res.data.code == 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
            // console.log(res);
        },
        //查看
        handleSizeChange(pageSize) {
            this.pageNum = 1;
            this.searchInfo.pageSize = pageSize;
            this.getSysInfoList();
        },

        handleCurrentChange(pageNum) {
            this.searchInfo.pageNum = pageNum;
            this.getSysInfoList();
        }
    }
};
</script>
<style lang="less" scoped>
.el-table {
    margin-top: 20px;
}
.el-pagination {
    margin-top: 20px;
    text-align: center;
}
</style>
